<div class="row">
  <div class="col">
    <div class="pl-0">
      <div style="background-color: #ecf0f4;position: sticky; top: 56px; z-index: 3;">
        <div class="wccard p-2 mb-1">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <!-- (click)="goToDetailsPage('project-details')" -->
              <div class="f-14 font-weight-600 blue-text mb-1 text-truncate"
                matTooltip="{{projectDetails?.projectname | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                style="width: 500px;">
                {{projectDetails?.projectname | titlecase}}
              </div>

              <div class="text-9696 f-12"><i class="fa-solid fa-briefcase mr-1"></i>{{projectDetails?.jobtitles[0]
                |
                titlecase}}, <span *ngIf="projectDetails?.jobtitles?.length > 1"
                  matTooltip="{{chipCleanUp(projectDetails?.jobtitles?.slice(1)?.toString())}}"
                  [matTooltipClass]="{ 'red-tooltip': true }">+{{projectDetails?.jobtitles?.length - 1}}</span>
                  <i class="fa-sharp fa-solid fa-pipe mx-1"></i><span><i
                    class="fa-solid fa-location-dot mr-1"></i>
                    <span *ngIf="projectDetails?.locations?.length > 0">
                      {{chipCleanUp(projectDetails?.locations[0]) | titlecase}}
                      <span *ngIf="projectDetails?.locations?.length > 1"
                        matTooltip="{{chipCleanUp(projectDetails?.locations?.slice(1))}}"
                        [matTooltipClass]="{ 'red-tooltip': true }">+{{projectDetails?.locations?.length - 1}}</span>
                    </span>
                    <!-- <span *ngIf="!projectDetails?.locations?.length">{{projectDetails?.location | titlecase}}</span> -->
                   <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit" class="mr-1">|</span> <span *ngIf="projectDetails?.distance && projectDetails?.distanceunit">Distance: {{projectDetails?.distance}} {{projectDetails?.distanceunit}}</span></span>
              </div>
            </div>

            <!-- <span class="f-14 text-color pointer" (click)="redirectToInsights()"
              style="border: 1px solid #2E93A1; padding: 7px;">View Project Insights</span> -->

              <div class="d-flex align-items-center">
                <div class="toggle-container mr-1">
                  <span class="activebtn">Candidates</span>
                  <span class="inactivebtn" (click)="redirectToInsights()">Project Insights</span>
                </div>

                <span class="dropdown ats-dropBtn px-2 mr-1 ml-3">
                <button data-testid="auto-app-ai-sourcing-profiles-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
                  appDropdownToggle aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="userDropdownButton" >
                  <a data-testid="auto-app-ai-sourcing-profiles-a-1" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="goToDetailsPage('project-details')"
                   ><i class="fa-light fa-file-lines mr-2"></i> Project Details</a>
                  <a data-testid="auto-app-ai-sourcing-profiles-a-2" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="goToDetailsPage('autopilot-criteria')">
                   <i class="fa-solid fa-sparkles mr-2"></i> Autopilot Criteria
                  </a>
                  <a data-testid="auto-app-ai-sourcing-profiles-a-3" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="goToDetailsPage('autopilot-activity')">
                    <i class="fa-light fa-clock-rotate-left mr-2"></i> Activity
                  </a>
                </div>
              </span>



              </div>
          </div>


        </div>

        <div class="wccard mb-1 d-flex justify-content-between align-items-center talenpool-sticky-header">
          <div class="d-flex align-items-center w-60">
            <label class="wc-checkbox mb-0 ml-2"
              *ngIf="(isShortlisted && projectCount?.shortlisted > 0) || (isReview && projectCount?.unactioned > 0) || (isArchieved && projectCount?.archive > 0)">
              <input data-testid="auto-app-ai-sourcing-profiles-input-1" [(ngModel)]="selected" (change)="selectAll($event)" type="checkbox" id="mycheck" name="mycheck">
              <i class="fas fa-check"></i>
            </label>
            <div class="d-flex justify-content-between w-100 ml-3">
              <span class="py-2 f-12 font-weight-500 pointer pl-3 pr-3 text-9696 d-flex justify-content-center align-items-center"
                (click)="onTabChange('toReview')"
                [ngClass]="{'isActive': isReview, 'tab': !isReview}"
              >
              <i class="fa-solid fa-users mr-1"></i>
              <span>
                To Review
              </span>
              <span class="count-circle">{{projectCount?.unactioned || 0}}</span>
              </span>

              <span class="py-2 f-12 font-weight-500 pointer px-3 text-9696 d-flex justify-content-center align-items-center" (click)="onTabChange('shortlist')"
                [ngClass]="{'isActive': isShortlisted, 'tab': !isShortlisted}">
                <i class="fa-solid fa-user-plus mr-1"></i>
                 <span>Shortlisted</span>
                 <span class="count-circle">{{projectCount?.shortlisted || 0}}</span>
              </span>
              <span class="py-2 f-12 font-weight-500 pointer px-3 ai-active text-9696 d-flex justify-content-center align-items-center"
                (click)="onTabChange('archieved')"
                [ngClass]="{'isActive': isArchieved, 'tab':!isArchieved }"
               >
                <i class="fa-solid fa-user-minus mr-1"></i>
                 <span>Archived</span>
                <span class="count-circle">{{projectCount?.archive || 0}}</span>
              </span>
              <!-- <span class="py-2 f-12 font-weight-500 pointer px-3 ai-active text-9696 d-flex justify-content-center align-items-center"
                [ngClass]="{'isActive': isActivity, 'tab':!isActivity}"
                (click)="onTabChange('activity')" >
                <i class="fa-regular fa-chart-line mr-1"></i>Activities
              </span> -->
            </div>
          </div>

          <div class="d-flex pr-2 align-items-center" *ngIf="selectedAllCandidates?.length > 0">
            <div class="mr-3" *ngIf="showAlert">
             <span class="f-12"> <span class="font-weight-600">{{selectedAllCandidates.length}}</span> Candidates Selected </span>
          </div>
            <button data-testid="auto-app-ai-sourcing-profiles-button-2" class="btn-trms-small hover-btn sm-reg-btn"  matTooltip="Download" [matTooltipClass]="{ 'red-tooltip text-black': true }" style="min-width: 30px;" (click)="bulkExport()">
              <i class="fa-solid fa-download" ></i>
            </button>
            <button data-testid="auto-app-ai-sourcing-profiles-button-3" class="btn-trms-regular archive sm-reg-btn ml-2"  matTooltip="Archive" [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="changeCandidateStatus('archive')"
              *ngIf="isShortlisted || isReview">
              <i class="fa-solid fa-user-minus"></i>
            </button>
            <button data-testid="auto-app-ai-sourcing-profiles-button-4" class="btn-trms-small ml-2 hover-btn px-0 sm-reg-btn"  matTooltip="Shortlist" [matTooltipClass]="{ 'red-tooltip text-black': true }" (click)="changeCandidateStatus('shortlisted')"*ngIf="isReview || isArchieved">
              <i class="fa-solid fa-user-plus"></i>
            </button>

            <button data-testid="auto-app-ai-sourcing-profiles-button-5" class="btn-trms-regular hover-btn ml-2 sm-reg-btn" (click)="openAddToEmailCampaign()" *ngIf="isShortlisted" matTooltip="Add To Email Campaign" [matTooltipClass]="{ 'red-tooltip text-black': true }">
              <i class="fa-solid fa-envelopes-bulk"></i>
            </button>
          </div>

          <!-- <div  class="d-flex justify-content-center align-items-center" *ngIf="!isActivity && (isShortlisted || isArchieved)">
            <div class="mr-3" *ngIf="totalCandidatesCount">
              <span class="font-weight-600"> {{start==0? 1 : start+1}} - {{end}}</span> of   <span class="font-weight-600">{{formatNumberToIndianFormat(totalCandidatesCount)}}</span>
              </div>
          </div> -->


        </div>
      </div>

      <div *ngIf="projectDetails">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ng-template #addCandidateToEmailCampaign>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
    <button data-testid="auto-app-ai-sourcing-profiles-button-6" type="button" class="close font-weight-normal ms-auto btn p-0 f-20"  data-dismiss="modal" aria-label="Close"
      (click)="closeActiveModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-2 mt-2">
      <div class="col">
        <input data-testid="auto-app-ai-sourcing-profiles-input-2" type="text" name="campaign_name" class="wc-form-control no-shadow w-100 inputheight mb-2"
          placeholder="Enter Campaign Name...." [formControl]="campaign_input" [matAutocomplete]="campaign_name"
          (input)="onTypeAheadSearch($event.target.value)" (click)="onTypeAheadSearch($event.target.value)" />
        <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
          class="f-12 text-danger">Campaign Name is required</p>
        <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
          <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="row mb-0">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-ai-sourcing-profiles-button-7" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaign()"
          [disabled]="!campaign_input.valid && isLoadingEmailCampaignApi">
          <span [ngClass]="{ 'spinner-border spinner-size': isLoadingEmailCampaignApi }"
            [ngStyle]="{ 'width: 20px; height: 20px;': isLoadingEmailCampaignApi }">
            {{isLoadingEmailCampaignApi ? '' : 'Add'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- <div *ngIf="showAlert" class="ai-sourcing-alert fade show" role="alert">
  <span> ({{selectedAllCandidates.length}}) Candidates Selected </span>
  <span class="close-alert" (click)="closeAlert()"><i class="fa-regular fa-x"></i></span>
</div> -->


<!-- Access management modal templates -->
<ng-template #accessManagementModal class="modal">
  <div class="modal-content p-3">
    <div class="text-center justify-content-between align-items-center">
        <p class="f-14 font-weight-600">This Job is Inactive</p>
        <p>To continue sourcing, please increase your team’s active project slots or contact Admin to deactivate another active project and activate this one.</p>
    </div>



  </div>
</ng-template>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span> <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600" style="text-decoration: underline;" (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)">"{{campaignName}}".</span></p>
  </div>
</ng-template>
